import React, { useRef } from 'react';
import classnames from 'classnames';
import CommonBubble from '@home/components/CommonBubble';
import useIsTextOverflow from './_hooks/useIsTextOverflow';
import type { BubbleProps } from 'tea-component';

import './index.scss';

interface IEllipsisHoverProps extends Omit<BubbleProps, 'children'> {
  text: string;
  bubbleText?: string;
  maxLines?: number; // 支持指定最大行数，默认为 1
  className?: string;
  style?: React.CSSProperties;
  // 可选：自定义显示内容（如高亮后的 ReactNode）。
  // 传入后显示以 children 为准，溢出检测与 tips 内容仍以 text 为准
  children?: React.ReactNode;
}

const EllipsisHover: React.FC<IEllipsisHoverProps> = (props) => {
  const {
    style,
    className,
    placement = 'top',
    text,
    bubbleText,
    maxLines = 1,
    children,
    overlayClassName,
  } = props;
  const wrapper = useRef<HTMLDivElement | null>(null);
  const isOverflow = useIsTextOverflow(wrapper, { text, maxLines });

  return (
    <div style={style} className={classnames('dba-ellipsis-hover', className)}>
      <CommonBubble
        dark
        arrowPointAtCenter
        overlayClassName={classnames('dba-ellipsis-hover__text-bubble', overlayClassName)}
        placement={placement}
        content={!isOverflow ? undefined : bubbleText ?? text}
      >
        <span
          ref={wrapper}
          className={classnames('dba-ellipsis-hover__text-wrapper', {
            'dba-ellipsis-hover__text-wrapper--multiline': maxLines > 1,
          })}
          style={
            maxLines > 1
              ? {
                display: '-webkit-box',
                WebkitLineClamp: maxLines,
                WebkitBoxOrient: 'vertical',
              }
              : undefined
          }
        >
          <span className="dba-ellipsis-hover__text-content">{children ?? text}</span>
        </span>
      </CommonBubble>
    </div>
  );
};

export default EllipsisHover;

